import { message, notification } from "antd";
import React, { useState, useEffect } from "react";
import { Form, Button, Col, Card, Dropdown } from "react-bootstrap";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import axiosInstance from "../../utils/api";

const SensorEdit = () => {
  //fetch api http://api.cl-ds.com/adminGetNodeSelection/
  const [data, setData] = useState({
    prefix: [],
    serial: [],
    filteredSerial: [],
    sensor: [],
  });

  const [values, setvalues] = useState({
    sensor: [],
    // sensor_set: [],
  });

  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      sensor: values.sensor,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "sensor",
  });

  //To Find Specific Serial Data
  //--------------------------CHANGED // GET SERIAL DATA-----------------------------------------
  const getApi = () => {
    axiosInstance("https://api.cl-ds.com/kaviSensor2/" + values.serial)
      .then((fetchdata) => {
        console.log(fetchdata.data);
        // setvalues(prevData => ({
        //   ...prevData,
        //   prefix: fetchdata.prefix,
        //   serial: fetchdata.serial,
        //   sensor: fetchdata.sensor
        // }))
        setValue("sensor", fetchdata.data.sensor);
        message.success("Serial:" + values.serial + " has been loaded");
      });

    console.log(SensorEdit);
  };
  //--------------------------GET SERIAL DATA-----------------------------------------

  //gets data for "Serial Prefix, and Serial"
  //Serial area
  //--------------------------CHANGED--------------------------------------------------
  useEffect(() => {
    axiosInstance("https://api.cl-ds.com/adminGetNodeList/")
      .then((fetchdata) => {
        console.log(fetchdata.data);
        setData((prevData) => ({
          ...prevData,
          prefix: fetchdata.data.prefix,
          serial: fetchdata.data.serial,
          sensor: fetchdata.data.sensor,
        }));
      });
  }, []);

  //gets data for "add", Displays the data in the add sector of the form which includes
  //--------------------------FORM DATA DISPLAY-----------------------------------------
  useEffect(() => {
    axiosInstance.get("https://api.cl-ds.com/adminGetSensorSelection/")
      .then((fetchdata) => {
        setData((prevData) => ({
          ...prevData,
          category: !!fetchdata?.data.category.length ? fetchdata.data.category : [],
          parameter: !!fetchdata?.data.parameter.length ? fetchdata.data.parameter : [],
          visualization: !!fetchdata?.data.visualization.length ? fetchdata.data.visualization : [],
          summary_chart: !!fetchdata?.data.summary_chart.length ? fetchdata.data.summary_chart : [],
        }));
        console.log(fetchdata.data);
      });
  }, []);

  //View Data
  const handleOnSubmit = async (formdata) => {
    const sensordata = formdata.sensor.map((item) => {
      return {
        ...item,
        prefix: values.prefix,
        serial: values.serial,
        sensor_set: values.sensor_set,
      };
    });

    const formData = {
      ...values,
      sensor: sensordata,
    };

    localStorage.setItem("formdata", JSON.stringify(formData));

    notification.open({
      message: "Form Data",
      duration: 0,
      description: JSON.stringify(formData),
      onClick: () => {
        console.log("Button was clicked");
      },
    });
    console.log(formData);
  };

  const handleClick = (formdata) => {
    const formData = {
      serial: values.serial,
      sensor_set: values.sensor_set,
      sensor: formdata.sensor,
    };
    console.log(values);
    console.log(formData);

    localStorage.setItem("formdata", JSON.stringify(formData));

    //sends to post api
    const SendOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token 4ef76b7b1288bbda537123e0fd51a446bd0b0a2f",
      },
      body: JSON.stringify(formData),
    };
    //Display message
    axiosInstance.get("https://api.cl-ds.com/adminRegisterSensorV3/", formData).then((response) => {
      if (response.status === 200) {
        return response.json();
      }
    });
    // .then((data) => {
    //   console.log(data.message);
    //   message.success(data.message);
    // });
  };

  const onChangehandler = (e) => {
    setvalues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  //on prefix change
  const prefixOnChange = (e) => {
    setvalues({
      ...values,
      prefix: e,
    });
    const filtered = data.serial.filter((item) => item.substring(0, 2) === e);
    setData((prevData) => ({
      ...prevData,
      filteredSerial: filtered,
    }));
    setvalues({
      ...values,
      serial: filtered[0] || "",
    });
  };

  return (
    <>
      <span></span>
      <div className="col-lg-8 mx-auto">
        <Form onSubmit={handleSubmit(handleClick)}>
          <h2 className="text-center pb-3"> Dashboard/Sensor Edit </h2>

          <Card>
            <Card.Header style={{ backgroundColor: "#7952b3", color: "white" }}> Sensor Edit </Card.Header>

            <Card.Body className="p-2">
              <div style={{textAlign:"end"}}>
                <Button variant="outline-primary" type="primary" onClick={handleSubmit(handleOnSubmit)}>
                  View Data
                </Button>
              </div>

              <Form.Group className="col-12">
                <Form.Label>Serial Prefix</Form.Label>
                <Form.Control as="select" name="prefix" className="form-control" value={values.prefix} onChange={(e) => prefixOnChange(e.target.value)} custom>
                  <option value="none" selected>
                    Select an Option
                  </option>
                  {!!data?.prefix?.length &&
                    data.prefix.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>Serial</Form.Label>
                <Form.Control as="select" name="serial" className="form-control" value={values.serial} onChange={(e) => onChangehandler(e)} custom>
                  <option value="none" selected>
                    Select an Option
                  </option>
                  {!!data.filteredSerial?.length &&
                    data.filteredSerial.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>
            </Card.Body>
          </Card>

          {/* <Form.Group className="col-6">
          <Form.Label>Sensor_Set</Form.Label>
          <Form.Control type="number" name="sensor_set" value={values.sensor_set} placeholder="sensor_set" onChange={(e) => onChangehandler(e)}></Form.Control>
        </Form.Group> */}

          <ul>
            {fields.map((item, index) => (
              <li style={{ listStyle: "none" }} key={item.id}>
                <span></span>
                <Card>
                  <Card.Header style={{ backgroundColor: "#7952b3", color: "white" }}>Sensor {index + 1}</Card.Header>
                  <Card.Body>
                    <Dropdown name={`sensor.${index}.category`} control={control} defaultValue={item.category} label="category" placeholder="category" options={data?.category} />
                    <Controller
                      name={`sensor.${index}.category`}
                      control={control}
                      defaultValue={item.category}
                      render={({ field }) => (
                        <>
                          <Form.Group as={Col}>
                            <Form.Label>category</Form.Label>
                            <Form.Control as="select" placeholder="category" className="form-control" required custom {...field}>
                              <option value="none" selected>
                                Select an Option
                              </option>
                              {!!data?.category?.length &&
                                data.category.map((item) => (
                                  <option key={item} value={item}>
                                    {item}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        </>
                      )}
                    />
                    <Controller
                      name={`sensor.${index}.parameter`}
                      control={control}
                      defaultValue={item.parameter}
                      render={({ field }) => (
                        <>
                          <Form.Group as={Col}>
                            <Form.Label>Parameter</Form.Label>
                            <Form.Control as="select" placeholder="parameter" required custom {...field}>
                              <option value="none" selected>
                                Select an Option
                              </option>
                              {!!data?.parameter?.length &&
                                data.parameter.map((item) => (
                                  <option key={item} value={item}>
                                    {item}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        </>
                      )}
                    />
                    <Controller
                      name={`sensor.${index}.visualization`}
                      control={control}
                      defaultValue={item.visualization}
                      render={({ field }) => (
                        <>
                          <Form.Group as={Col}>
                            <Form.Label>Visualization</Form.Label>
                            <Form.Control as="select" placeholder="Visualization" required custom {...field}>
                              <option value="none" selected>
                                Select an Option
                              </option>
                              {!!data?.visualization?.length &&
                                data.visualization.map((item) => (
                                  <option key={item} value={item}>
                                    {item}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        </>
                      )}
                    />

                    <Controller
                      name={`sensor.${index}.summary_chart`}
                      control={control}
                      defaultValue={item.summary_chart}
                      render={({ field }) => (
                        <>
                          <Form.Group as={Col}>
                            <Form.Label>Summary_chart</Form.Label>
                            <Form.Control as="select" placeholder="Summary_chart" required custom {...field}>
                              <option value="none" selected disabled hidden>
                                Select an Option
                              </option>
                              {!!data?.summary_chart?.length &&
                                data.summary_chart.map((item) => (
                                  <option key={item} value={item}>
                                    {item}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        </>
                      )}
                    />

                    <Controller
                      name={`sensor.${index}.alarm_enabled`}
                      control={control}
                      defaultCheck={item.alarm_enabled}
                      render={({ field: { value, ...field } }) => (
                        <>
                          <Form.Group>
                            <Form.Check label="Alarm Enable" inline checked={value} type="checkbox" placeholder="Alarm Enable" {...field} />
                          </Form.Group>
                        </>
                      )}
                    />

                    <Controller
                      name={`sensor.${index}.slider_enabled`}
                      control={control}
                      defaultCheck={item.slider_enabled}
                      render={({ field: { value, ...field } }) => (
                        <>
                          <Form.Group>
                            <Form.Check label="Slider Enable" inline checked={value} type="checkbox" placeholder="Slider Enable" {...field} />
                          </Form.Group>
                        </>
                      )}
                    />

                    <Controller
                      name={`sensor.${index}.visual_enabled`}
                      control={control}
                      defaultCheck={item.visual_enabled}
                      render={({ field: { value, ...field } }) => (
                        <>
                          <Form.Group>
                            <Form.Check label="Visual Enable" inline checked={value} type="checkbox" placeholder="Visual Enable" {...field} />
                          </Form.Group>
                        </>
                      )}
                    />

                    <Controller
                      name={`sensor.${index}.chart_enabled`}
                      control={control}
                      defaultCheck={item.chart_enable}
                      render={({ field: { value, ...field } }) => (
                        <>
                          <Form.Group>
                            <Form.Check label="Chart Enable" inline checked={value} type="checkbox" placeholder="Chart Enable" {...field} />
                          </Form.Group>
                        </>
                      )}
                    />

                    <Controller
                      name={`sensor.${index}.modbus_factor`}
                      control={control}
                      defaultValue={item.modbus_factor}
                      render={({ field }) => (
                        <>
                          <Form.Group as={Col}>
                            <Form.Label>Modbusfactor</Form.Label>
                            <Form.Control type="text" placeholder="Modbusfactor" required {...field}></Form.Control>
                          </Form.Group>
                        </>
                      )}
                    />

                    <Controller
                      name={`sensor.${index}.cal_coeff`}
                      control={control}
                      defaultValue={item.cal_coeff}
                      render={({ field }) => (
                        <>
                          <Form.Group as={Col}>
                            <Form.Label>Calcoeff</Form.Label>
                            <Form.Control type="text" placeholder="Calcoeff" required {...field}></Form.Control>
                          </Form.Group>
                        </>
                      )}
                    />

                    <Controller
                      name={`sensor.${index}.cal_const`}
                      control={control}
                      defaultValue={item.cal_const}
                      render={({ field }) => (
                        <>
                          <Form.Group as={Col}>
                            <Form.Label>Calconst</Form.Label>
                            <Form.Control type="text" placeholder="Calconst" required {...field}></Form.Control>
                          </Form.Group>
                        </>
                      )}
                    />

                    <button
                      type="button"
                      class="btn btn-danger"
                      onClick={() => {
                        console.log(index);
                        remove(index);
                      }}
                    >
                      Delete
                    </button>
                  </Card.Body>
                </Card>
                <span></span>
              </li>
            ))}
          </ul>

          <button
            type="button"
            class="btn btn-success"
            onClick={() =>
              append({
                category: "",
                parameter: "",
                visualization: "",
                alarm_enable: false,
                slider_enable: false,
                visual_enable: false,
                chart_enable: false,
                modbus_factor: "*1",
                cal_coeff: "1",
                cal_const: "0",
              })
            }
          >
            Add
          </button>

          <Button className="mr-3" style={{ float: "right" }} onClick={getApi}>
            Load Sensor Data
          </Button>
          <div className="d-flex justify-content-center mb-5">
            <Button variant="outline-primary" type="submit">
              Submit
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default SensorEdit;
